// extracted by mini-css-extract-plugin
module.exports = {"customer-service-wrapper":"i1_M_W_N"};